import { REMOVER_FILTRO_ITINERARIO } from '../types'

export default function removerFiltroItinerario (filtro) {
  return {
    payload: filtro,
    type: REMOVER_FILTRO_ITINERARIO
  }
}
